import { fg } from '@atlaskit/platform-feature-flags/fg';

import { PrimaryProductKeys } from '../../../../common/constants/primary-product-keys';
import type { PrimaryProductKey } from '../../../../common/constants/product-keys';

export const getUrsProductKey = (
	primaryProduct?: PrimaryProductKey,
): 'confluence' | 'jira' | 'loom' => {
	if (primaryProduct === PrimaryProductKeys.Loom && fg('rovo_fps_use_loom_urs_product_key')) {
		return PrimaryProductKeys.Loom;
	}

	// URS (User Recommendation Service) rejects product keys it does not recognise, so anything
	// else falls back to 'confluence' rather than failing deserialization.
	return primaryProduct === PrimaryProductKeys.Jira ||
		primaryProduct === PrimaryProductKeys.Confluence
		? primaryProduct
		: PrimaryProductKeys.Confluence;
};
